import Vue from 'vue'

Vue.config.productionTip = false

import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import App from './App.vue';
import router from './router/index'
import './assets/css/reset.css'
Vue.use(ElementUI);


new Vue({
  router,//挂载router
  render: h => h(App),
}).$mount('#app')
